import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ReportService} from '../../../services/report.service';
import {ReportInfoDTO} from '../../../model/reportInfoDTO';
import {ShouldPreviewService} from '../../../services/should-preview-service';

@Component({
  templateUrl: './payment-succeeded.component.html',
})
export class PaymentSucceededComponent implements OnInit {

  reportInfo: ReportInfoDTO;

  constructor(private route: ActivatedRoute,
              private shouldPreviewService: ShouldPreviewService,
              private router: Router,
              public reportService: ReportService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.getReportInfo(params['reportId']));
  }

  private getReportInfo(reportId: number) {
    this.reportService.getInfo(reportId).subscribe(reportInfo => this.reportInfo = reportInfo);
  }

  toReport() {
    this.shouldPreviewService.reset();
    const {clientId, type, year} = this.reportInfo;
    this.router.navigate(this.reportService.getReportUrl(clientId, type, year));
  }
}
